var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataJourney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 86.7 86.7",
    style: {
      enableBackground: "new 0 0 86.7 86.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.9,52c0-1-0.5-1.9-1.4-2.3c-0.7-0.4-1.3-0.7-2-1.1l-5-2.8l-5,5.8c-0.1-0.8-0.2-1.5-0.3-2.1 c0-0.3,0-0.6,0.1-0.9c0.2-0.6,0.4-1.2,0.7-1.8c0.1-0.4,0-0.5-0.4-0.5c-0.9,0-1.7,0-2.6,0c-0.4,0-0.5,0.2-0.4,0.6s0.5,1,0.7,1.6 c0.1,0.2,0.2,0.4,0.2,0.7c-0.1,0.8-0.2,1.7-0.4,2.6l-5.1-5.8c-2.4,1.3-4.7,2.6-7,3.9c-0.9,0.5-1.4,1.4-1.3,2.5v8 c0,0.2,0,0.3,0,0.5h29.1c0-0.1,0-0.2,0-0.2C57.9,57.6,57.9,54.8,57.9,52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.6,39.2c-0.3,0.1-0.5,0.1-0.8,0.1c-2.2-0.2-3.8-2.2-3.5-4.4c0.2-1.9,1.7-3.3,3.5-3.5c0.3,0,0.5,0,0.8,0.1 v-5.4c-0.5,0-0.9,0-1.4,0c-0.4,0-0.6,0.1-0.7,0.5c-0.2,0.6-0.4,1.2-0.6,1.7c-0.1,0.2-0.2,0.3-0.4,0.4c-0.7,0.5-1.6,0.5-2.2,0 c-0.3-0.2-0.7-0.4-1.1-0.5c-0.1,0-0.3,0-0.4,0.1c-0.5,0.4-0.9,0.8-1.3,1.3c0.4,0.7,0.7,1.4,1,2.1c0.1,0.2,0.1,0.5,0,0.7 c-0.1,0.8-0.7,1.4-1.5,1.5c-0.5,0.1-1,0.3-1.5,0.5v2.1c0.8,0.3,1.5,0.5,2.2,0.8c0.2,0.1,0.3,0.2,0.5,0.4c0.5,0.6,0.5,1.5,0,2.2 c-0.3,0.4-0.5,0.9-0.6,1.4c0.1,0.4,0.7,0.7,1,1.1c0.2,0.3,0.5,0.4,0.9,0.3c0.1,0,0.1-0.1,0.1-0.1c0.5-0.3,1-0.6,1.6-0.8 c0.2-0.1,0.4-0.1,0.6,0c0.8,0.1,1.5,0.8,1.6,1.6c0.1,0.5,0.2,1.1,0.5,1.3s0.9,0,1.4,0.1c0.1,0,0.2,0,0.3,0L42.6,39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.7,26c5.1,0.2,9.1,4.5,9,9.6c-0.2,4.9-4.1,8.8-9,9V26z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataJourney);
export default __webpack_public_path__ + "static/media/data-journey.c87accd176a0e02e0cc395b3d0ace585.svg";
export { ForwardRef as ReactComponent };